import React from 'react'
import './Popup.scss'

const Popup = ({ handleClose, className, content, children, isOpenModal }) => {
  const onBackdropClick = (e) => {
    if (e.target === e.currentTarget && handleClose) handleClose()
  }
  return (
    <div
      className={`modal fade show ${className} ${isOpenModal ? 'd-block' : ''}`}
      id='popup_modal'
      onClick={onBackdropClick}
    >
      <div className='modal-dialog modal-lg modal-dialog-centered mx-auto'>
        <div className='modal-content'>
          {/* <!-- MODAL BODY --> */}
          <div className='modal-body'>
            {children}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Popup
